import instance from '../instance';
import getLiveElement from '../accessors/get-live-element';
import prepareSerializedStaticDocument from '../utils/helpers/prepare-serialized-static-document';

const insertElement = (element, refElementId, position, updateStrategy) => {
  const refElement = getLiveElement(refElementId);
  instance.driver.insertElement(element, refElement, position, updateStrategy);
  const clonedStaticDOM = instance.driver.getStaticDocument().cloneNode(true);
  return prepareSerializedStaticDocument(clonedStaticDOM);
};

export default insertElement;
